<div class="doc-icon" [style.--size.px]="size" [style.--accent]="accent()" [attr.aria-label]="ariaLabel()">
  <svg viewBox="-2 -2 84 104" role="img" aria-hidden="false">
    <path d="M10 2 h40 l20 20 v76 a10 10 0 0 1 -10 10 h-50 a10 10 0 0 1 -10 -10 v-86 a10 10 0 0 1 10 -10 z" fill="white"
      stroke="var(--accent)" stroke-width="3" />
    <path d="M50 2 v18 a6 6 0 0 0 6 6 h18" fill="var(--accent)" />
    <rect x="10" y="2" width="40" height="3" fill="var(--accent)" />
    <g [attr.transform]="'translate(40,60)'">
      <rect x="-28" y="-18" rx="6" ry="6" width="56" height="36" [attr.fill]="badgeFill()" [attr.stroke]="accent()"
        stroke-width="2" />
      <text text-anchor="middle" dominant-baseline="middle" [attr.font-size]="fontSize()" font-weight="700" fill="white"
        style="font-family: system-ui, Inter, Roboto, 'Helvetica Neue', Arial;">
        {{ label() }}
      </text>
    </g>
    <rect x="18" y="76" width="44" height="6" rx="3" [attr.fill]="accent()" opacity="0.18" />
    <rect x="18" y="86" width="32" height="6" rx="3" [attr.fill]="accent()" opacity="0.18" />
  </svg>
</div>